import React, { Component } from 'react';
import { Button, Card } from 'react-bootstrap';
import TreeScreen from './TreeScreen';
import { TopicVo } from '../classes/dataObjects/TopicVo';
import { MainStorage } from '../classes/MainStorage';
import { DataCenter } from '../classes/DataCenter';
import { CatVo } from '../classes/dataObjects/CatVo';
interface MyProps { }
interface MyState { mode: number, selectedTopic: TopicVo | null }
class BaseScreen extends Component<MyProps, MyState> {
    private ms: MainStorage = MainStorage.getInstance();
    constructor(props: MyProps) {
        super(props);
        this.state = { mode: 0, selectedTopic: null };
    }
    componentDidMount() {

        //check subject parameter
        let urlParams = new URLSearchParams(window.location.search);
        let subject: string | null = urlParams.get('subject');

        //langauge =1
        //literature =2
        //history =3
        //vocabulary =4
        //math =5
        //biography =6
        //geography =7
        //science =8
        //art =9
        if (subject !== null) {
            let subjects: string[] = ["", "language", "literature", "history", "vocabulary", "math", "biography", "geography", "science", "art"];

            let index: number = subjects.indexOf(subject);

            if (index > 0) {
                this.ms.subjectID = index;
            }
        }
        this.checkSecurity();
    }
    getScreen() {
        switch (this.state.mode) {
            case 0:
                return "Loading...";
            case 1:
                return <TreeScreen callback={this.setTopic.bind(this)} />;

            default:
                return "No screen found";
        }
    }
    setTopic(topic: TopicVo) {
        this.setState({ selectedTopic: topic });
    }
    goToLink(topic: TopicVo) {
        //$slug.= "-".$subjectID . "-" . $catID . "-" . $subCatID;
        let slug:string=topic.slug+"-"+topic.subjectID+"-"+topic.catID+"-"+topic.subCatID;
        window.open("https://memorywizards.com/play/?goto=" + slug);
    }
    getPopUp() {
        if (this.state.selectedTopic === null) return null;
        let image: string = "https://memorywizards.com/api/direct/getTopicImage.php?subjectID=" + this.state.selectedTopic.subjectID + "&topicID=" + this.state.selectedTopic.id + "&size=0"
        const topicVo: TopicVo = this.state.selectedTopic;

        if (this.ms.subjectID === 1) {
            image = "https://memorywizards.com/api/direct/getLangImage.php?diff=" + this.state.selectedTopic.difficulty + "&icon=" + this.state.selectedTopic.icon + "&size=2";
        }

        return <div className='popup'>
            <Card>
                <button className='btnClose' onClick={() => this.setState({ selectedTopic: null })}>X</button>
                <Card.Body>
                    <h3>{topicVo.topicName}</h3>
                    <div className='topicImage' style={{ backgroundImage: `url(${image})` }}></div>
                    <Card.Text>
                        {topicVo.blurb}
                    </Card.Text>
                    <Button className='btnGo' variant="primary" onClick={() => this.goToLink(topicVo)}>Go</Button>
                </Card.Body>
            </Card>
        </div>
    }
    checkSecurity() {

        const userCodeDiv: HTMLDivElement | null = window.parent.document.getElementById("mw_uc") as HTMLDivElement;
        if (userCodeDiv) {
            this.ms.userCode = userCodeDiv.innerText;
            if (this.ms.userCode !== "") {
                this.ms.isLoggedIn = true;
                DataCenter.getUserInfo((data: any) => {

                    this.ms.gems = parseInt(data.gems);
                    this.ms.xp = parseInt(data.xp);
                    this.ms.streak = parseInt(data.streak);
                    this.ms.userLevel = parseInt(data.memberLevel);
                    this.ms.userName = data.nicename;
                    //isAdmin 0 is not admin, 1 is admin
                    this.ms.isAdmin = (parseInt(data.isAdmin) === 1) ? true : false;
                    // mc.showMessageAlert("Welcome " + ms.userName + "!");
                    //mc.gotUserInfo();
                    this.getSubjects();
                }, this.ms.userCode);
            }
            else {
                this.getSubjects();
            }


        }

    }
    getSubjects() {
        DataCenter.getSubjects(this.gotSubjects.bind(this));
    }
    gotSubjects(data: any) {
        let items: CatVo[] = [];
        for (let i: number = 0; i < data.length; i++) {
            const iconPath1: string = "https://memorywizards.com/images/icons/subjects/" + data[i].icon + ".png";
            //console.log(iconPath1);
            items.push(new CatVo(parseInt(data[i].id), parseInt(data[i].id), data[i].subjectName, iconPath1));
            console.log(data[i]);
        }
        this.ms.subjects = items;
        this.setState({ mode: 1 });
    }
    /*  const userCodeDiv: HTMLDivElement | null = window.parent.document.getElementById("mw_uc") as HTMLDivElement;
     if(userCodeDiv) {
         //console.log("userCodeDiv", userCodeDiv.innerText);
         ms.userCode = userCodeDiv.innerText;
 
         if (ms.userCode !== "") {
 
 
             ms.isLoggedIn = true;
 
             DataCenter.sayHello(() => {
                 DataCenter.getUserInfo((data: any) => {
                     //console.log(data);
                     ms.gems = parseInt(data.gems);
                     ms.xp = parseInt(data.xp);
                     ms.streak = parseInt(data.streak);
                     ms.userLevel = parseInt(data.memberLevel);
                     ms.userName = data.nicename;
                     //isAdmin 0 is not admin, 1 is admin
                     ms.isAdmin = (parseInt(data.isAdmin) === 1) ? true : false;
                     // mc.showMessageAlert("Welcome " + ms.userName + "!");
                     mc.gotUserInfo();
                 }, ms.userCode);
             }, ms.userCode); */
    render() {
        return (<div id="base">
            <header><h1>Topic Progress Explorer</h1></header>
            {this.getScreen()}
            {this.getPopUp()}
        </div>)
    }
}
export default BaseScreen;